import { render, staticRenderFns } from "./assignment-table.vue?vue&type=template&id=376b6c5e"
import script from "./assignment-table.vue?vue&type=script&lang=js"
export * from "./assignment-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports